<div
  class="cookie-consent-wrapper gpx-24 gpt-24 gpb-16 shadow bg-white d-print-none"
>
  <div class="d-flex flex-column flex-md-row">
    <img
      src="/assets/images/cookies.svg"
      class="mb-3 mb-md-0 mx-auto gmr-md-24"
    />
    <div
      class="p4-regular text-secondary"
      [innerHTML]="'COOKIESNOTICEPOPUP.TEXT' | translate"
    ></div>
  </div>
  <div
    class="d-flex flex-column align-items-center flex-md-row-reverse justify-content-md-start gmt-16 mx-auto"
  >
    <!-- <button class="btn text-primary" (click)="showCookiePolicy()">
      <span translate="COOKIESNOTICEPOPUP.POLICYBUTTON"></span>
    </button> -->

    <button
      class="gbtn-1 gbtn-sq b2-semibold text-primary gmx-12 gmy-12"
      (click)="acceptCookies()"
    >
      <span>{{ 'COOKIESNOTICEPOPUP.ACCEPT' | translate }}</span>
    </button>
    <button
      class="gbtn-3 gbtn-sq b2-semibold text-primary gmx-12 gmy-12"
      (click)="openCookieSettings()"
    >
      <span>{{ 'COOKIESNOTICEPOPUP.SETTINGSBUTTON' | translate }}</span>
    </button>
  </div>
</div>
